export const TOAST_VARIANTS = {
    SUCCESS: "success", ERROR: "error", WARNING: "warning", INFO: "info", DEFAULT: "default"
}